import { setShowProjectCompleteModal } from '../State/showProjectCompleteModal';

export default () => async (dispatch) => {

  dispatch(setShowProjectCompleteModal(false));
  
}